import * as React from "react";
import { useSelector } from "react-redux";

function ExtendVmIcon({ width = 16, height = 16, ...props }) {
    const { isDarkTheme } = useSelector(({ common }) => common);
    return (
        <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width={width}
                height={height} viewBox="0 0 21 21"><path fill="none" stroke={isDarkTheme ? "#62BAB3" : "#3c4252"} {...props} stroke-linecap="round" stroke-linejoin="round" d="M15.5 9.5V5.522l-4-.022m-2 10.023h-4V11.5" /></svg>
        </span>
    );
}

export default ExtendVmIcon;

